import { handleLocationField } from "../../../hooks/form-helpers";
import { getConfig } from "../../../hooks/use-config";
import { validationMessage } from "../../../utils/validation";

export const onChangeAddressInfo = (props, cb) => {
  let detailData = {};
  const { value, key, formFields, errors } = props;
  const updateFormFields = { ...formFields };

  if (key !== "location") {
    errors[key] = "";
    updateFormFields[key].value = value;
    if (key === "countryCode") {
      updateFormFields.stateCode.elementConfigs.apiURL = `/states/${value}`;
      updateFormFields.stateCode.value = "";

      updateFormFields.city.elementConfigs.apiURL = "";
      updateFormFields.city.value = "";
    } else if (key === "stateCode") {
      const { countryCode } = updateFormFields;
      updateFormFields.city.elementConfigs.apiURL = `/cities/${countryCode.value}/${value}`;
      updateFormFields.city.value = "";
    }

    detailData = { updatedFields: updateFormFields, fieldErrors: errors };
    cb(detailData);
  } else {
    const { fields, fieldErrors } = handleLocationField(
      value,
      key,
      formFields,
      errors
    );
    detailData = { updatedFields: fields, fieldErrors };
    cb(detailData);
  }
};

export const getSubmissionData = (formFields, submittedUpdateFormData) => {
  const fieldsData = submittedUpdateFormData ? submittedUpdateFormData : {};
  const required = {};

  for (let key in formFields) {
    const { elementConfigs, value } = formFields[key];

    if (value) {
      const alert = checkInputConstraints(elementConfigs, key, value);
      if (alert) {
        required[key] = alert;
      } else {
        fieldsData[key] = formFields[key].value;
      }
    } else if (!value && elementConfigs.required) {
      required[key] = validationMessage.required;
    }
  }

  return {
    fieldsData,
    required,
  };
};

const checkInputConstraints = (configs, key, value) => {
  const { maxLength, minLength } = configs;

  let errorMessage = "";

  switch (true) {
    case maxLength && value.length > maxLength:
      errorMessage = getConfig(key);
      break;
    case minLength && value.length < minLength:
      errorMessage = getConfig(key);
      break;
    case value.length === maxLength && value.length === minLength:
      errorMessage = "";
      break;
    default:
      return errorMessage;
  }

  return errorMessage;
};

export const prepareAddressFormData = (
  supplierDetail,
  formDataFields,
  countryOptions,
  cb
) => {

  for (let key in formDataFields) {
    if (supplierDetail[key]) {
      const value = supplierDetail[key];

      formDataFields[key].value = value;

      if (key === "countryCode") {
        formDataFields[key].options = countryOptions;
        formDataFields["stateCode"].elementConfigs.apiURL = `/states/${value}`;
        cb(formDataFields);
      }
    } else if (key === "location") {
      const { elementConfigs } = formDataFields[key];
      formDataFields[key].value = {
        latitude: supplierDetail.latitude,
        longitude: supplierDetail.longitude,
      };

      formDataFields[key].elementConfigs = {
        ...elementConfigs,
        addressText: supplierDetail.address1,
      };

      delete supplierDetail.latitude;
      delete supplierDetail.longitude;
    } else {
      formDataFields[key].value = "";
    }
  }

  return formDataFields;
};
